import { render, staticRenderFns } from "./UserAccountDetails.vue?vue&type=template&id=38f3fffd"
import script from "./UserAccountDetails.vue?vue&type=script&lang=js"
export * from "./UserAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./UserAccountDetails.vue?vue&type=style&index=0&id=38f3fffd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports